export default {
  planInfo: [],
  options:[],
  error: false,
  errorMessage: ''
}